var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kendo-dropdownlist',{style:({ width: '300px' }),attrs:{"data-source":_vm.entries,"data-text-field":'Name',"data-value-field":'IdUserGroup',"optionLabel":_vm.label},on:{"select":_vm.onChanged},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})
}
var staticRenderFns = []

export { render, staticRenderFns }